import React from "react";
import { motion } from "../components/StaticMotion";
import { HoverCard } from "../components/HoverMotion";

export const SectionOurStory = () => {
  const timeline = [
    {
      year: "2023",
      event: "Early Initiative",
      description:
        "We began exploring purpose-built digital solutions for sports events through pilot projects, testing timing systems and tracking platforms in real race environments. These early experiments laid the technical and operational foundations for everything that followed.",
    },
    {
      year: "2024",
      event: "Platform Development",
      description:
        "A dedicated year of research and engineering. We developed our core platforms — live timing, GPS tracking, and event registration — iterating rapidly with early partners and refining every system to meet the demanding standards of competitive sports.",
    },
    {
      year: "2025",
      event: "Company Formation",
      description:
        "PT. Visi Ekosistem Digital was officially established, formalizing our commitment to the event technology industry. We launched the full VIONIXASIA suite — bringing integrated, production-ready platforms to organizers across Indonesia.",
    },
  ];

  return (
    <section id="our-story" className="w-full py-16 lg:py-24 px-4 bg-white overflow-hidden">
      <motion.div
        className="w-full max-w-6xl mx-auto"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.6 }}
      >
        <div className="text-center mb-10">
          <motion.h2
            className="text-3xl md:text-4xl font-black text-gray-900 uppercase tracking-tight mb-3"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            Our Story
          </motion.h2>
          <motion.p
            className="text-gray-600 max-w-3xl mx-auto"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
          >
            A journey of continuous innovation and growth, driven by a single goal: to deliver smarter, more reliable, and more engaging event experiences through technology.
          </motion.p>
        </div>

        {/* Timeline */}
        <div className="relative overflow-visible">
          <div
            className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px -translate-x-1/2 z-0 bg-slate-200"
            style={{ height: "calc(100% + 2rem)", top: "-1rem" }}
          />

          {timeline.map((item, index) => (
            <motion.div
              key={index}
              className="relative mb-4"
              initial={{ opacity: 0, y: 25 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.15, duration: 0.6, ease: "easeOut" }}
            >
              <div className={`flex flex-col md:flex-row md:gap-6 items-center ${index % 2 === 0 ? "" : "md:flex-row-reverse"}`}>
                <motion.div
                  className={`w-full md:w-5/12 ${index % 2 === 0 ? "md:text-right" : "md:text-left"}`}
                >
                  <HoverCard className={`p-4 rounded-card border border-slate-200 ${index === 1 ? "bg-slate-900" : "bg-white"}`}>
                    <span className={`inline-block text-xs font-bold px-3 py-1 rounded-full mb-4 border ${index === 1 ? "bg-white/10 text-white border-white/20" : "bg-slate-100 text-slate-600 border-slate-200"}`}>
                      {item.year}
                    </span>
                    <h3 className={`text-lg font-bold mb-1 ${index === 1 ? "text-white" : "text-slate-900"}`}>
                      {item.event}
                    </h3>
                    <p className={`text-sm leading-relaxed ${index === 1 ? "text-slate-300" : "text-slate-600"}`}>
                      {item.description}
                    </p>
                  </HoverCard>
                </motion.div>

                <div className="hidden md:block absolute left-1/2 w-3 h-3 bg-slate-900 rounded-full border-2 border-white -translate-x-1/2 z-10 shadow-sm" />
                <div className="hidden md:block md:w-5/12" />
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};
